export { BannerComponent } from './banner.component';
export { BannerConfig, BannerContent, BannerType, isBannerConfig } from './banner.model';
